class Article {
    CurrentArticle() {
        $(window).on('load', function(){
            $('#block-block-stats-actualites .view-content .views-row, #block-block-stats-campagnes .view-content .views-row').each(function(){
                if($(this).find('a').attr('href') == window.location.pathname){
                    $(this).find('a').addClass('current');
                }
            })
        });
    }
}

export default Article;